var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.visible,
            title: "Sửa giá khoản phụ",
            size: "lg",
            "cancel-text": "Hủy",
            "confirm-text": "Lưu lại",
            "confirm-loading": _vm.loading,
            "use-panel": false,
            top: "6vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            confirm: _vm.handleSubmit,
            cancel: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "poe-content" },
            [
              _c("div", { staticClass: "poe-tip mb-4" }, [
                _c("i", { staticClass: "el-icon-info poe-tip-icon" }),
                _c("span", { staticClass: "poe-tip-text" }, [
                  _vm._v(
                    "\n          Điều chỉnh đơn giá và chính sách giảm giá riêng cho từng khoản phụ trong công thức tính. Dữ liệu gốc hiển thị bên cạnh để đối chiếu.\n        "
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "poe-decimal-toggle mb-4" },
                [
                  _c("span", [_vm._v("Cho phép số thập phân")]),
                  _c("el-switch", {
                    attrs: {
                      value: _vm.allowDecimal,
                      "active-text": "Có",
                      "inactive-text": "Không",
                    },
                    on: { change: _vm.handleAllowDecimalChange },
                  }),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "overrideForm",
                  staticClass: "poe-form",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.formRules,
                    "label-width": "0",
                  },
                },
                _vm._l(_vm.formData.overrides, function (item, index) {
                  return _c(
                    "div",
                    { key: item.id || index, staticClass: "poe-item" },
                    [
                      _c(
                        "div",
                        { staticClass: "poe-item-head" },
                        [
                          _c("span", { staticClass: "poe-alias" }, [
                            _vm._v(_vm._s(item.alias)),
                          ]),
                          _c("span", { staticClass: "poe-name" }, [
                            _vm._v(_vm._s(item.principalName)),
                          ]),
                          _c(
                            "el-tag",
                            { staticClass: "poe-original-tag ml-2" },
                            [
                              _vm._v(
                                "\n              Gốc: " +
                                  _vm._s(_vm.formatMoney(item.originalPrice)) +
                                  " x " +
                                  _vm._s(
                                    _vm.formatQuantity(item.originalQuantity)
                                  ) +
                                  " " +
                                  _vm._s(item.originalUnit) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "poe-item-body", attrs: { gutter: 16 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: item.discount ? 5 : 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "overrides." + index + ".price",
                                    rules: _vm.priceRules,
                                    "label-width": "0",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "poe-field-label" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-money mr-1",
                                      }),
                                      _vm._v("Đơn giá (VNĐ)\n                "),
                                    ]
                                  ),
                                  _c("ElCurrencyInput", {
                                    staticClass: "sk-u-w-full",
                                    attrs: {
                                      options: {
                                        locale: "vi-VN",
                                        precision: 0,
                                        autoDecimalMode: false,
                                        distractionFree: false,
                                      },
                                    },
                                    model: {
                                      value: item.price,
                                      callback: function ($$v) {
                                        _vm.$set(item, "price", $$v)
                                      },
                                      expression: "item.price",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: item.discount ? 3 : 5 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "overrides." + index + ".quantity",
                                    rules: _vm.quantityRules,
                                    "label-width": "0",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "poe-field-label" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-pie-chart mr-1",
                                      }),
                                      _vm._v("Số lượng\n                "),
                                    ]
                                  ),
                                  _c("el-input", {
                                    staticClass: "sk-u-w-full",
                                    attrs: {
                                      type: "number",
                                      step: _vm.allowDecimal ? 0.01 : 1,
                                    },
                                    model: {
                                      value: item.quantity,
                                      callback: function ($$v) {
                                        _vm.$set(item, "quantity", _vm._n($$v))
                                      },
                                      expression: "item.quantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: item.discount ? 4 : 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { "label-width": "0" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "poe-field-label" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-box mr-1",
                                      }),
                                      _vm._v("Đơn vị\n                "),
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "sk-u-w-full",
                                      attrs: {
                                        filterable: "",
                                        "allow-create": "",
                                        "default-first-option": "",
                                        placeholder: "Đơn vị",
                                      },
                                      model: {
                                        value: item.unit,
                                        callback: function ($$v) {
                                          _vm.$set(item, "unit", $$v)
                                        },
                                        expression: "item.unit",
                                      },
                                    },
                                    _vm._l(_vm.unitsList, function (u) {
                                      return _c("el-option", {
                                        key: u,
                                        attrs: { label: u, value: u },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: item.discount ? 4 : 5 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { "label-width": "0" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "poe-field-label" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-price-tag mr-1",
                                      }),
                                      _vm._v("Giảm giá\n                "),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "poe-switch-wrapper" },
                                    [
                                      _c("el-switch", {
                                        attrs: {
                                          "active-text": "Có",
                                          "inactive-text": "Không",
                                          "active-color": "#10b981",
                                          "inactive-color": "#cbd5e1",
                                        },
                                        on: {
                                          change: (val) =>
                                            _vm.onDiscountToggle(index, val),
                                        },
                                        model: {
                                          value: item.discount,
                                          callback: function ($$v) {
                                            _vm.$set(item, "discount", $$v)
                                          },
                                          expression: "item.discount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          item.discount
                            ? _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { "label-width": "0" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "poe-field-label" },
                                        [_vm._v("Loại giảm")]
                                      ),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "sk-u-w-full",
                                          attrs: { placeholder: "Chọn" },
                                          model: {
                                            value: item.discountType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "discountType",
                                                $$v
                                              )
                                            },
                                            expression: "item.discountType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "%",
                                              value: "PERCENT",
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "VNĐ",
                                              value: "MONEY",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.discount
                            ? _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { "label-width": "0" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "poe-field-label" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                item.discountType === "PERCENT"
                                                  ? "Phần trăm (%)"
                                                  : "Số tiền"
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      item.discountType === "MONEY"
                                        ? [
                                            _c("ElCurrencyInput", {
                                              staticClass: "sk-u-w-full",
                                              attrs: {
                                                options: {
                                                  locale: "vi-VN",
                                                  precision: 0,
                                                  autoDecimalMode: false,
                                                  distractionFree: false,
                                                },
                                              },
                                              model: {
                                                value: item.discountNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "discountNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.discountNumber",
                                              },
                                            }),
                                          ]
                                        : [
                                            _c("el-input-number", {
                                              directives: [
                                                {
                                                  name: "discount-percent",
                                                  rawName: "v-discount-percent",
                                                },
                                              ],
                                              staticClass: "sk-u-w-full",
                                              attrs: {
                                                min: 0,
                                                max: 100,
                                                precision: 0,
                                                "controls-position": "right",
                                              },
                                              model: {
                                                value: item.discountNumber,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "discountNumber",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.discountNumber",
                                              },
                                            }),
                                          ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "poe-item-summary-bar mt-3" }, [
                        _c("div", { staticClass: "poe-summary-item" }, [
                          _c("span", { staticClass: "poe-summary-label" }, [
                            _vm._v("Thành tiền gốc:"),
                          ]),
                          _c("span", { staticClass: "poe-summary-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatMoney(_vm.getItemOriginalTotal(item))
                              )
                            ),
                          ]),
                        ]),
                        item.discount
                          ? _c(
                              "div",
                              { staticClass: "poe-summary-item text-danger" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "poe-summary-label" },
                                  [_vm._v("Số tiền được giảm:")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "poe-summary-value" },
                                  [
                                    _vm._v(
                                      "-" +
                                        _vm._s(
                                          _vm.formatMoney(
                                            _vm.getItemDiscountAmount(item)
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "poe-summary-item poe-summary-item--final",
                          },
                          [
                            _c("span", { staticClass: "poe-summary-label" }, [
                              _vm._v("Tổng sau giảm:"),
                            ]),
                            _c("span", { staticClass: "poe-summary-value" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatMoney(_vm.getItemFinalTotal(item))
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }